// src/components/LoginPage.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// Import Google-specific auth methods, and also getAuth
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from '../firebaseConfig'; // Your initialized Firebase auth instance

function LoginPage() {
  // --- Email/Password state (kept but not used for Google login) ---
  // const [email, setEmail] = useState('');
  // const [password, setPassword] = useState('');
  // --- End Email/Password state ---

  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Get the auth instance (passed as prop to component or from firebaseConfig)
  // Using getAuth() directly ensures it's the same instance used in App.js
  const firebaseAuth = getAuth();

  // --- Google Sign-in Logic ---
  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider(); // Create a new Google Auth provider
    setError(''); // Clear any previous errors

    try {
      // Open a pop-up window for Google Sign-in
      await signInWithPopup(firebaseAuth, provider);
      navigate('/cloud-tts'); // Redirect to the Cloud TTS page after successful login
    } catch (error) {
      console.error("Error with Google Sign-In:", error);
      // Firebase auth errors have a 'code' and 'message'
      setError(error.message); // Display the error message to the user
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">Login</h2>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
            <strong className="font-bold">Error!</strong>
            <span className="block sm:inline"> {error}</span>
          </div>
        )}

        {/* Google Sign-in Button */}
        <button
          onClick={handleGoogleSignIn}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg mb-4 transition duration-300 ease-in-out flex items-center justify-center"
        >
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google logo" className="w-5 h-5 mr-2" />
          Sign in with Google
        </button>

        {/* --- Email/Password Form (Commented Out as requested) --- */}
        {/*
        <div className="relative flex py-5 items-center">
          <div className="flex-grow border-t border-gray-400"></div>
          <span className="flex-shrink mx-4 text-gray-400">OR</span>
          <div className="flex-grow border-t border-gray-400"></div>
        </div>

        <form onSubmit={handleEmailPasswordSignIn}>
          <div className="mb-4">
            <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">Email:</label>
            <input
              type="email"
              id="email"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-6">
            <label htmlFor="password" className="block text-gray-700 text-sm font-bold mb-2">Password:</label>
            <input
              type="password"
              id="password"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-lg transition duration-300 ease-in-out"
          >
            Login with Email
          </button>
        </form>
        */}
        {/* --- End Email/Password Form --- */}

        {/* Registration link (optional - uncomment if you have a /register route) */}
        {/*
        <p className="text-center text-gray-600 text-sm mt-4">
          Don't have an account? <Link to="/register" className="text-blue-500 hover:text-blue-700">Register here</Link>
        </p>
        */}
      </div>
    </div>
  );
}

export default LoginPage;